import React, { FunctionComponent } from 'react';
import './index.scss';

import { commonComponentsStyle, themeColor } from '../../../../types/style.global';

interface SubTitleProps {
  title: string;
}

const SubTitle: FunctionComponent<SubTitleProps> = (props) => {
  const { title } = props

  const background = commonComponentsStyle.SubTitle.background
  const justifyContent = commonComponentsStyle.SubTitle.justifyContent
  const textMargin = commonComponentsStyle.SubTitle.textMargin
  const backgroundColor = commonComponentsStyle.SubTitle.backgroundColor

  return (
    (title !== 'Impacts') ?
      (<div className='subtitle-main-div' style={{ background: backgroundColor }}>
        <div className='anchor' style={{backgroundColor: themeColor.defaultMode.barChartBarColor}}></div>
        <div className='text'>{title}</div>
      </div>)
    : (
      <div className='subtitle-main-div'
        style={ (title === 'Impacts') ? {
          background,
          justifyContent,
        } : {}}
      >
        <div className='text' style={{ margin: textMargin }}>{title}
        </div>
        <div className='anchor'></div>
      </div>
    )

  )
}

export default SubTitle